import { render, staticRenderFns } from "./LoginRoute.vue?vue&type=template&id=65acda3a&"
import script from "./LoginRoute.vue?vue&type=script&lang=ts&"
export * from "./LoginRoute.vue?vue&type=script&lang=ts&"
import style0 from "./LoginRoute.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports